import { KeyValueObject } from "models/KeyValueObject";
import React from "react";

type ReportDetailsFieldProps = {
  detail: KeyValueObject;
  isReversedDecision: boolean;
};
const ReportDetailsField = ({
  detail,
  isReversedDecision,
}: ReportDetailsFieldProps) => {
  const fieldClassName = () => {
    if (isReversedDecision && detail.label === "החלטה") {
      return "reversedText";
    }
    return "text";
  };
  return (
    <div className="dtContainer" key={detail.label}>
      <div className="title">{detail.label}</div>
      <div className={fieldClassName()}>{detail.value || ""}</div>
    </div>
  );
};
export default ReportDetailsField;
